export const knownDomains = [
    "go.glideapps.com",
    "app.heyglide.com",
    "app.glideapps.com",
    "staging.heyglide.com",
    "staging.glideapps.com",
    "localhost",
];

function isKnownDomain(hostname: string) {
    const isKnown = knownDomains.some(d => d === hostname);

    return isKnown;
}

export function isCustomDomain(hostname: string, ipv4IsCustom: boolean = false): boolean {
    return (
        !isKnownDomain(hostname) &&
        !(/\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(hostname) && !ipv4IsCustom) &&
        !hostname.endsWith(".firebaseapp.com")
    );
}
